<form class="space-y-sm" [formGroup]="form | bgoAsFormGroup" *transloco="let t">
  <label class="mt-xs mb-2 block font-bold">
    {{ t('createJobRequest.boilerDescaling.boilerSizeInLiters.label') }}
  </label>

  @for (liters of volumeOptionsInLiters; track liters) {
    <cft-radio class="mt-xs block" [formControl]="form.controls.boilerSizeInLiters | bgoAsFormControl" [value]="liters">
      {{ t('createJobRequest.boilerDescaling.boilerSizeInLiters.upTo', {volume: liters}) }}
    </cft-radio>

    <!-- add last option "More than {{lastVolume}}" with an arbitrary step of 100 liters -> calculator should return unknown() anyway -->
    @if ($last) {
      <cft-radio
        class="mt-xs block"
        [formControl]="form.controls.boilerSizeInLiters | bgoAsFormControl"
        [value]="liters + 50"
      >
        {{ t('createJobRequest.boilerDescaling.boilerSizeInLiters.moreThan', {volume: liters}) }}
      </cft-radio>
    }
  }
</form>
